import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

/* Which chapter of an audiobook file is playing at `time`: embedded marks when the file has them, else the whole file. */
export const chapterAt = (track, time) => {
  const emb = track?.chapters || [];
  const dur = track?.duration || 0;
  if (emb.length >= 2 && dur) {
    let i = 0;
    for (let k = 0; k < emb.length; k++) if (emb[k].start <= time + 0.01) i = k;
    const end = i + 1 < emb.length ? emb[i + 1].start : dur;
    return { start: emb[i].start, duration: Math.max(0, Math.round((end - emb[i].start) * 100) / 100), title: emb[i].title, index: i };
  }
  return { start: 0, duration: dur, title: track?.title, index: 0 };
};

/* Text of one chapter from the attached ebook, paced by word count over the chapter's duration (no AI, no cost). */
export const useChapterText = (track, chapterStart, enabled) => {
  const [tr, setTr] = useState({ status: "idle" });
  const [tick, setTick] = useState(0);
  const k = track && enabled && track.album_id ? `${track.album_id}|${track.id}|${Math.round(chapterStart || 0)}` : null;
  useEffect(() => {
    if (!k) { setTr({ status: "idle" }); return undefined; }
    let stop = false;
    setTr((s) => (s.status === "idle" ? { status: "loading" } : s));
    api.get(`/ebooks/${track.album_id}/chapter`, { params: { track_id: track.id, start: chapterStart || 0 } })
      .then(({ data }) => { if (!stop) setTr(data); })
      .catch((e) => { if (!stop) setTr({ status: "error", error: formatApiError(e) }); });
    return () => { stop = true; };
  }, [k, tick]); // eslint-disable-line react-hooks/exhaustive-deps
  return { tr, refresh: () => setTick((x) => x + 1) };
};

/* Ebook attached to a book + which chapters it covers. */
export const useBookText = (albumId) => {
  const [sum, setSum] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!albumId) return undefined;
    let stop = false;
    api.get(`/ebooks/${albumId}`).then(({ data }) => { if (!stop) setSum(data); }).catch(() => {});
    return () => { stop = true; };
  }, [albumId, tick]);
  return { sum, refresh: useCallback(() => setTick((x) => x + 1), []) };
};

export const uploadEbook = (albumId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/ebooks/${albumId}`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data.ebook);
};
export const removeEbook = (albumId) => api.delete(`/ebooks/${albumId}`);
export const searchGutenberg = (albumId, q) => api.get(`/ebooks/${albumId}/gutenberg`, { params: q ? { q } : {} }).then((r) => r.data);
export const attachGutenberg = (albumId, bookId, title) => api.post(`/ebooks/${albumId}/gutenberg/${bookId}`, null, { params: title ? { title } : {} }).then((r) => r.data.ebook);
